import { fields } from "@monorepo/utils/src/variables/projectsData/fundsListReport/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.FILTER_ARCHIVE]: {},
});
